const getCurrentMonth = () => new Date().getMonth() + 1;

export default getCurrentMonth;
